import styles from "./intro.module.css";
import Card from "../Game/Card/card";
import { color } from "../Data/cards";
import { useState, useLayoutEffect } from "react";
import { RightOutlined, SwapRightOutlined } from "@ant-design/icons";
import { Button } from "antd";

const Intro = ({}) => {
  const myCards = [
    { name: "사랑", color: color.red, distance: 1 },
    { name: "꿈", color: color.yellow, distance: 3 },
    { name: "감사", color: color.green, distance: 3 },
    { name: "여행", color: color.blue, distance: 2 },
    {
      name: "색바꾸기",
      color: color.black,
      fontColor: [color.darkyellow, color.blue, color.red, color.green],
    },
  ];
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return (
    <div className={styles.panel}>
      <div className={styles.info}>
        <p>
          <b>아이엠(IAM)</b>은 적은 그룹에서 자신을 소개하고 서로를 알아가는
          과정을 즐거운 게임형태로 할 수 있는 카드게임입니다
          <Button
            className={styles.gameinfo}
            icon={<SwapRightOutlined />}
            type="link"
          >
            게임 설명 보러가기
          </Button>
        </p>
      </div>

      <div className={styles.cardBoard}>
        {myCards.map((value, index) => {
          const idx = index - (Object.keys(myCards).length - 1) / 2;
          const angle = (10 * idx * Math.PI) / 180;
          const left = `calc(50% - 70px + ${250 * Math.sin(angle)}px)`;
          const top = `calc(50% - 30px - ${100 * Math.cos(angle)}px)`;

          const rotate = 10 * idx;
          console.log(Math.sin(angle), Math.cos(angle), rotate);
          return (
            <div
              className={styles.cards}
              style={{
                position: "absolute",
                left: left,
                transform: `scale(0.6) rotate(${rotate}deg) 
                  translateY(calc(100% + 250px - ${Math.cos(angle) * 500}px))`,
              }}
            >
              <Card
                name={value.name}
                distance={value.distance}
                color={value.color}
                fontColor={value.fontColor}
                select={false}
                mode="intro"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Intro;
